export const ClaimCardTypes = Object.freeze({
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  PASSWORD: 'PASSWORD',
  NONE: 'NONE',
})
